<template>
  <span>
    <span @click="pick">
      <slot name="trigger"></slot>
    </span>

    <input
      ref="input"
      class="is-hidden"
      type="file"
      @input="onInput"
      :accept="acceptAttr"
    />
  </span>
</template>

<script>
export default {
  props: {
    autoClear: {
      type: Boolean,
      default: false
    },

    accept: {
      type: String
    }
  },

  data() {
    return {
      file: null
    };
  },

  computed: {
    acceptAttr() {
      if (this.accept === "audio") {
        return ".mp3,audio/*";
      } else if (this.accept === "image") {
        return "image/x-png,image/gif,image/jpeg";
      } else {
        return this.accept;
      }
    }
  },

  methods: {
    pick() {
      this.$refs.input.click();
    },

    onInput() {
      this.file = this.$refs.input.files[0];

      this.$emit("picked", this.file);

      if (this.autoClear) {
        this.clear();
      }
    },

    clear() {
      this.$refs.input.value = "";
    }
  }
};
</script>
